import React, {Component, ReactElement, ReactNode} from 'react'
import {
    ADMINISTORATOR_MODE,
    EVENT_CATEGORY,
    EVENT_ITEM_CLEANING,
    EVENT_ITEM_GARBAGE_DAY,
    EVENT_ITEM_MAINTENANCE,
    EVENT_ITEM_OTHER,
    EVENT_ITEM_OTHER_EVENTS,
    PREFECTURES_MASTER,
    VIEW_DO_OR_NOT,
    YES_OR_NOT,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {PageFooterArea, PageFotterAreaLeft, PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material'
import NatScheduleRepo from '../schedule/repository/NatScheduleRepo'
import {NatGetSchedule, ScheduleNotDeliveryCondominiumList} from '../schedule/repository/NatGetSchedule'
import NatEventRepo from '../event/repository/NatEventRepo'
import {NatGetEvent} from './repository/NatGetEvent'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {getScheduleSettingInfo} from '../../common/util/Natutil'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import styled from 'styled-components'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
} from '../condominium/repository/NatGetCondominiumList'
import {SortOrder} from '../../../components/shared/SortOrder'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
}

interface Props {
    scheduleId: string
    seq: string
    scheduleRepo: NatScheduleRepo
    eventRepo: NatEventRepo
    eventEmitter: EventEmitterExAdmin
    condominiumRepo: NatCondominiumRepo
    location: Location<LocationState>
}

interface States {
    schedule: NatGetSchedule
    scheduleTitle: string
    eventCategory: string
    eventItem: string
    scheduleTermDate: string
    description: string
    scheduleSetting: string
    condominiumName: string,
    condominiumGroupName: string,
    scheduleNotDeliveryCondominium: ScheduleNotDeliveryCondominiumList[],
    deliveryTargetPrefectureCd: string,
    deliveryTargetAddress2: string,
    scheduleDeliveryTargetCondominiumList: CondominiumInfo[],
    scheduleAssignDate: string
    operationDate: string
    invisible: string
    isLoadCompleted: boolean
    deleteImpossibleFlg: boolean
}


class NatAdminEventDetailsPage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>
    condominiumCd: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)
        this.condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)

        this.state = {
            schedule: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            scheduleTitle: '',
            eventCategory: '',
            eventItem: '',
            scheduleTermDate: '',
            description: '',
            scheduleSetting: '',
            scheduleNotDeliveryCondominium: [],
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            scheduleDeliveryTargetCondominiumList: [],
            condominiumName: '',
            condominiumGroupName: '',
            scheduleAssignDate: '',
            operationDate: '',
            invisible: '',
            isLoadCompleted: false,
            deleteImpossibleFlg: false,
        }
        this.backScheduleLinkClick = this.backScheduleLinkClick.bind(this)
        this.editEventLinkClick = this.editEventLinkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // スケジュール取得
            const schedule: Nullable<NatGetSchedule> = await this.props.asyncCallFunction(
                this.props.scheduleRepo.getSchedule.bind(this.props.scheduleRepo, this.props.scheduleId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            // イベント取得
            const event: Nullable<NatGetEvent> = await this.props.asyncCallFunction(
                this.props.eventRepo.getEvent.bind(this.props.scheduleRepo, this.props.scheduleId, this.props.seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (schedule && schedule.details &&
                event && event.details) {
                // イベントカテゴリ
                const eventCategoryMaster = EVENT_CATEGORY.codeToEnumConstants(schedule.details.eventCategory)
                let eventCategory: string = ''
                if (eventCategoryMaster) {
                    eventCategory = eventCategoryMaster.label
                }
                // イベント項目
                let eventItem: string = ''
                switch (schedule.details.eventCategory) {
                    case EVENT_CATEGORY.TRASH_DAY.value:
                        const garbageMaster =
                            EVENT_ITEM_GARBAGE_DAY.codeToEnumConstants(schedule.details.eventItem)
                        if (garbageMaster) {
                            eventItem = garbageMaster.label
                        }
                        break
                    case EVENT_CATEGORY.MAINTENANCE.value:
                        const maintenanceMaster =
                            EVENT_ITEM_MAINTENANCE.codeToEnumConstants(schedule.details.eventItem)
                        if (maintenanceMaster) {
                            eventItem = maintenanceMaster.label
                        }
                        break
                    case EVENT_CATEGORY.CLEANING.value:
                        const cleaningMaster =
                            EVENT_ITEM_CLEANING.codeToEnumConstants(schedule.details.eventItem)
                        if (cleaningMaster) {
                            eventItem = cleaningMaster.label
                        }
                        break
                    case EVENT_CATEGORY.OTHER_EVENT.value:
                        const otherEventsMaster =
                            EVENT_ITEM_OTHER_EVENTS.codeToEnumConstants(schedule.details.eventItem)
                        if (otherEventsMaster) {
                            eventItem = otherEventsMaster.label
                        }
                        break
                    case EVENT_CATEGORY.OTHER.value:
                        const otherMaster =
                            EVENT_ITEM_OTHER.codeToEnumConstants(schedule.details.eventItem)
                        if (otherMaster) {
                            eventItem = otherMaster.label
                        }
                        break
                    default:
                        break
                }
                // 実施期間
                let scheduleTermDate: string = ''
                if (!schedule.details.scheduleEndDate) {
                    scheduleTermDate = formatDateZeroPadding(schedule.details.scheduleStartDate)
                } else {
                    scheduleTermDate = `${formatDateZeroPadding(schedule.details.scheduleStartDate)}から
                    ${formatDateZeroPadding(schedule.details.scheduleEndDate)}まで`
                }

                // 削除可否
                const deleteImpossibleFlg: boolean = event.details.controlFlag === YES_OR_NOT.NO.value

                ReactDOM.flushSync(() => {
                    if (schedule && schedule.details &&
                        event && event.details) {
                        this.setState({
                            schedule: schedule,
                            scheduleTitle: schedule.details.title,
                            eventCategory: eventCategory,
                            eventItem: eventItem,
                            scheduleTermDate: scheduleTermDate,
                            description: schedule.details.description,
                            scheduleSetting: getScheduleSettingInfo(
                                schedule.details.repeatDate,
                                schedule.details.repeatWeekUnit,
                                schedule.details.repeatWeek,
                                schedule.details.repeatDayOfWeek),
                            condominiumName: schedule.details.condominiumName,
                            condominiumGroupName: schedule.details.condominiumGroupName,
                            scheduleNotDeliveryCondominium: schedule.details.scheduleNotDeliveryCondominium,
                            deliveryTargetPrefectureCd: schedule.details.deliveryTargetPrefectureCd ?
                                schedule.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: schedule.details.deliveryTargetAddress2 ?
                                schedule.details.deliveryTargetAddress2 : '',
                            scheduleAssignDate: event.details.scheduleAssignDate,
                            operationDate: event.details.operationDate,
                            invisible: event.details.invisible,
                            isLoadCompleted: true,
                            deleteImpossibleFlg: deleteImpossibleFlg,
                        })
                    }
                })
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    schedule.details.condominiumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchCondition = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                scheduleDeliveryTargetCondominiumList:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    backScheduleLinkClick(): void {
        this.props.navigate(`/admin/schedule/${this.props.scheduleId}`)
    }

    editEventLinkClick(): void {
        this.props.navigate(`/admin/eventEdit/${this.props.scheduleId}/${this.props.seq}`)
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    renderScheduleTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>スケジュール情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleTitle}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>イベントカテゴリ</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.eventCategory}
                            </TableCell>
                            <TableRowName>イベント項目</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.eventItem}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>説明文</TableRowName>
                            <TableCellWordBreakAll colSpan={4}>
                                <div dangerouslySetInnerHTML={{__html: this.state.description}}/>
                            </TableCellWordBreakAll>
                        </TableRow>
                        <TableRow>
                            <TableRowName>実施期間</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleTermDate}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>設定内容</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleSetting}
                            </TableCell>
                        </TableRow>
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName>対象グループ/物件</TableRowName>
                                    <TableCell colSpan={4}>
                                        {(this.state.condominiumName) ?
                                            this.state.condominiumName : this.state.condominiumGroupName}
                                    </TableCell>
                                </TableRow>
                                {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== '' ?
                                    <>
                                        <TableRow>
                                            <TableRowName>
                                                配信対象
                                            </TableRowName>
                                            <TableCell colSpan={4}>
                                                {`指定地域: ${this.getPrefectureName(this.state.deliveryTargetPrefectureCd)}
                                                ${this.state.deliveryTargetAddress2}`}
                                                {
                                                    <InnerMiniTable>
                                                        <InnerMiniTableBody>
                                                            {
                                                                this.state.scheduleDeliveryTargetCondominiumList.map(
                                                                    (condominiumInfo, index) => {
                                                                        return (
                                                                            <TableRow
                                                                                key={condominiumInfo.condominiumCd}>
                                                                                <InnerMiniTableCell>
                                                                                    {condominiumInfo.condominiumCd + ' ' +
                                                                                        condominiumInfo.condominiumName}
                                                                                </InnerMiniTableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })
                                                            }
                                                        </InnerMiniTableBody>
                                                    </InnerMiniTable>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    </>
                                    : <></>
                                }
                                <TableRow>
                                    <TableRowName>除外する物件</TableRowName>
                                    {this.state.scheduleNotDeliveryCondominium.map((scheduleNotDeliveryCondominium) => (
                                        <TableRow>
                                            <TableCell>
                                                {scheduleNotDeliveryCondominium.condominiumCd}
                                            </TableCell>
                                            <TableCell colSpan={3}>
                                                {scheduleNotDeliveryCondominium.condominiumName}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {this.state.scheduleNotDeliveryCondominium.length === 0 &&
                                        <TableCell colSpan={4}></TableCell>
                                    }
                                </TableRow>
                            </>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        if (this.state.deleteImpossibleFlg) {
            return (<></>)
        }
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CALENDAR_MANAGEMENT}>
                    <PageFotterAreaLeft>
                        <AdminPrimaryButton
                            onClick={this.editEventLinkClick}>
                            編集する
                        </AdminPrimaryButton>
                    </PageFotterAreaLeft>
                </AuthorityChecker>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backScheduleLinkClick}
                    >
                        スケジュール詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderEventTable(): ReactNode {
        // 非表示
        let invisible: string = ''
        const invisibleMaster =
            VIEW_DO_OR_NOT.codeToEnumConstants(this.state.invisible)
        if (invisibleMaster) {
            invisible = invisibleMaster.label
        }
        return (
            <>
                <Table>
                    <StyledTableCaption>イベント情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>実施日</TableRowName>
                            <TableCell colSpan={2}>
                                {formatDateZeroPadding(this.state.operationDate)}
                            </TableCell>
                            <TableRowName>スケジュール割り当て日</TableRowName>
                            <TableCell colSpan={2}>
                                {formatDateZeroPadding(this.state.scheduleAssignDate)}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>表示状態</TableRowName>
                            <TableCell colSpan={4}>
                                {invisible}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <Box mb={'15px'}>
                    <PageMainArea>
                        {this.renderScheduleTable()}
                    </PageMainArea>
                </Box>
                <Box mb={'15px'}>
                    <PageFooterArea>
                        {this.renderPageHeaderArea()}
                    </PageFooterArea>
                </Box>
                <PageMainArea>
                    {this.renderEventTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminEventDetailsPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
